<template>
    <div class="team-page flex flex-col align-start h-full">
        <div class="topbar w-full">
            <!-- <div class="title"> -->
            <!-- <span class="tab" :class="{ active: activeTab === 'space' }" @click="switchTab('space')">我的空间</span> -->
            <!-- <span class="tab" :class="{ active: activeTab === 'fav' }" @click="switchTab('fav')">我的收藏</span>
                <span class="tab" :class="{ active: activeTab === 'trash' }" @click="switchTab('trash')">回收站</span> -->
            <!-- </div> -->
            <div class="title">
                <span class="team-name">我的空间</span>
            </div>
            <div class="actions flex gap-2">
                <el-input placeholder="搜索当前库" v-model="searchText" class="team-search" @keyup.enter="onSearchEnter"
                    clearable @clear="clearSearch">
                    <template #suffix>
                        <el-icon class="el-input__icon cursor-pointer" @click="onSearchEnter">
                            <search />
                        </el-icon>
                    </template>
                </el-input>
                <el-dropdown trigger="click" @command="onActionCommand">
                    <el-button type="primary" class="upload-btn">新增/上传
                        <el-icon class="caret">
                            <ArrowDown />
                        </el-icon>
                    </el-button>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="upload">上传文件</el-dropdown-item>
                            <el-dropdown-item command="folder">创建文件夹</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <input ref="fileInput" type="file" multiple style="display:none" @change="onFileChange"
                    accept=".png,.jpg,.jpeg,.webp,.gif" />
                <div class="capacity w-[40px] h-[40px] flex items-center justify-center">
                    <el-progress type="circle" :percentage="((remainingCapacity.prop || 0) * 100).toFixed(0)" width="40"
                        stroke-width="4" color="#2a66ff" />
                </div>
            </div>
        </div>
        <FolderListBase v-show="activeTab === 'space'" ref="folderListRef" @select="onFolderSelect" root-label="我的空间" />
        <UploadDialog v-model:visible="uploadVisible" :folder="activeFolder" :files="selectedFiles"
            @addFiles="onAddFiles" @confirm="onUploadConfirm" @cancel="onUploadCancel" :currentTeam="currentTeam"
            @removeFile="onRemoveFile" />

        <div class="resource-bar cursor-pointer w-full">
            <div class="left flex items-center justify-between">
                <div class="leftType flex items-center gap-[10px]" v-if="activeTab === 'space' || activeTab === 'fav'">
                    <div class="type-item filter-ref " v-for="it in types" :key="it" @click="onTypeCommand(it)"
                        :class="{ 'typeActive': activeType === it }">{{
                            it }}</div>
                </div>
                <div class="leftType flex items-center gap-[10px]" v-else><el-icon>
                        <WarningFilled />
                    </el-icon> 回收站中的资源超过30天会自动删除</div>
                <div class="filters">
                    <el-dropdown trigger="click" @command="onSceneCommand" popper-class="filter-popper"
                        @visible-change="scenesVisible = $event">
                        <span class="filter-ref"
                            :class="{ open: scenesVisible, 'filter-refActive': activeScenes.id != '' }">
                            <span class="label">分类</span>
                            <span class="value" v-if="activeScenes.id != ''">：{{ activeScenes.name }}</span>
                            <el-icon class="caret">
                                <ArrowDown />
                            </el-icon>
                            <span class="clear" v-if="activeScenes.id != ''" @click.stop="clearScenes">
                                <el-icon>
                                    <Close />
                                </el-icon>
                            </span>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="it in scenes" :key="it.id" :command="it">{{ it.name
                                }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <el-dropdown trigger="click" @command="onFormatCommand" popper-class="filter-popper"
                        @visible-change="formatsVisible = $event">
                        <span class="filter-ref"
                            :class="{ open: formatsVisible, 'filter-refActive': activeFormats !== '全部' }">
                            <span class="label">格式</span>
                            <span class="value" v-if="activeFormats !== '全部'">：{{ activeFormats }}</span>
                            <el-icon class="caret">
                                <ArrowDown />
                            </el-icon>
                            <span class="clear" v-if="activeFormats !== '全部'" @click.stop="clearFormats">
                                <el-icon>
                                    <Close />
                                </el-icon>
                            </span>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="it in formats" :key="it" :command="it">{{ it
                                }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <el-dropdown trigger="click" @command="onTagCommand" popper-class="filter-popper"
                        :hide-on-click="false" @visible-change="tagsVisible = $event">
                        <span class="filter-ref" :class="{ open: tagsVisible, 'filter-refActive': activeTags.length }">
                            <span class="label">标签</span>
                            <span class="value" v-if="activeTags.length">：{{ activeTagsLabel }}</span>
                            <el-icon class="caret">
                                <ArrowDown />
                            </el-icon>
                            <span class="clear" v-if="activeTags.length" @click.stop="clearTags">
                                <el-icon>
                                    <Close />
                                </el-icon>
                            </span>
                        </span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="it in tags" :key="it.id" :command="it"
                                    :class="{ active: activeTags.findIndex((item) => item.id == it.id) >= 0 }">{{
                                        it.name }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>

        </div>
        <div class="material px-[24px] w-full flex-1 min-h-0 overflow-hidden">
            <ResourceMasonry ref="materialRef" :show-upload-when-empty="true" @upload="handleUpload" />
        </div>
        <div class="multiple-choice">
            <MultipleChoice @refresh="refresh" :activeFolder="activeFolder" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { ElButton, ElIcon } from 'element-plus'
import { Search, Plus, ArrowDown, ArrowRight } from '@element-plus/icons-vue'
//@ts-ignore
import FolderListBase from '@/views/shared/components/FolderListBase.vue'
//@ts-ignore
import UploadDialog from '@/views/shared/components/UploadDialog.vue'
//@ts-ignore
import ResourceMasonry from '@/views/shared/components/ResourceMasonry.vue'
//@ts-ignore
import MultipleChoice from '@/views/shared/components/multipleChoice.vue'

import { getTagPage, getCategoryPage, getCategorySuffixes } from '@/api/ResourceMasonry'
import { getResourceCapacity } from '@/api/affairs'
import { multipleChoiceStore } from "@/stores/multipleChoice"
const multipleChoice = multipleChoiceStore()
onMounted(() => {
    multipleChoice.clearSelected()
    getfilterPage()
    getCapacity()
})
const searchText = ref('')
const resources = ref<any[]>([])
const avatarStack = ref<string[]>([
    'https://file.aimano.xin/passport/system/dc1a6a7fb61647139a3d9f56c41726ff.png',
])
const types = ref(['全部', '模板', '素材'])
const scenes = ref([{ name: '全部', id: '' }])
const formats = ref(['全部'])
const tags = ref([{ name: '全部', id: '' }])

const activeTab = ref<'space' | 'fav' | 'trash'>('space')
const switchTab = (tab: 'space' | 'fav' | 'trash') => {
    activeTab.value = tab
    activeType.value = '全部'
    activeScenes.value = { name: '全部', id: '' }
    activeFormats.value = '全部'
    activeTags.value = []
    if (tab === 'space') {
        materialRef.value?.parentgetList?.({})
    }
}
const refresh = () => {
    materialRef.value?.parentgetList?.({})
    folderListRef.value?.refresh?.()
}
const activeType = ref('全部')
const activeScenes = ref({ name: '全部', id: '' })
const activeFormats = ref('全部')
const activeTags = ref<any[]>([])
const activeTagsLabel = computed(() => activeTags.value.length ? activeTags.value.map((it) => it.name).join(',') : '全部')
const typesVisible = ref(false)
const scenesVisible = ref(false)
const formatsVisible = ref(false)
const tagsVisible = ref(false)

const activeFolder = ref({})
const onFolderSelect = (f: any) => {
    activeFolder.value = f
    materialRef.value?.parentgetList?.({ currentFolder: f })
}
const materialRef = ref<any>(null)
const folderListRef = ref<any>(null)
const fileInput = ref<HTMLInputElement | null>(null)
const uploadVisible = ref(false)
const selectedFiles = ref<File[]>([])
const handleUpload = () => {
    fileInput.value?.click()
}
const onActionCommand = (cmd: string) => {
    if (cmd === 'upload') {
        fileInput.value?.click()
        return
    }
    if (cmd === 'folder') {
        folderListRef.value?.onCreateFolder?.()
        return
    }
}
const onFileChange = (e: Event) => {
    const fs = Array.from((e.target as HTMLInputElement).files || [])
    selectedFiles.value = fs
    uploadVisible.value = true
        ; (e.target as HTMLInputElement).value = ''
}
const onAddFiles = (fs: File[]) => { selectedFiles.value = [...selectedFiles.value, ...fs] }
const onRemoveFile = (i: number) => { selectedFiles.value.splice(i, 1) }
const onUploadConfirm = (payload: any) => {
    materialRef.value?.parentgetList?.()
    uploadVisible.value = false

}
const onUploadCancel = () => { uploadVisible.value = false }
const onTypeCommand = (v: string) => {
    console.log(v)
    activeType.value = v
    if (v == '素材') {
        materialRef.value?.parentgetList?.({ file_type: 2 })
    } else if (v == '模板') {
        materialRef.value?.parentgetList?.({ file_type: 1 })
    } else if (v == '全部') {
        materialRef.value?.parentgetList?.({ file_type: '' })
    }
}
const onSceneCommand = (v: { name: string; id: string }) => {
    activeScenes.value = v
    materialRef.value?.parentgetList?.({ category_id: v.id })
}
const onFormatCommand = (v: string) => {
    activeFormats.value = v
    materialRef.value?.parentgetList?.({ file_suffix: v })
}
const onTagCommand = (v) => {
    if (v.id == '') {
        activeTags.value = []
        return
    }
    const i = activeTags.value.findIndex((item: any) => item.id == v.id)
    if (i >= 0) {
        activeTags.value.splice(i, 1)
    } else {
        activeTags.value.push(v)
    }
    let ids = activeTags.value.map((item: any) => item.id).join(',')
    materialRef.value?.parentgetList?.({ tag_ids: ids })
}
const clearType = () => {
    activeType.value = '全部'
    materialRef.value?.parentgetList?.({ file_type: '' })
}
const clearScenes = () => {
    activeScenes.value = { name: '全部', id: '' }
    materialRef.value?.parentgetList?.({ category_id: '' })
}
const clearFormats = () => {
    activeFormats.value = '全部'
    materialRef.value?.parentgetList?.({ file_suffix: '' })
}
const clearTags = () => {
    activeTags.value = []
    materialRef.value?.parentgetList?.({ tag_ids: '' })
}
const clearSearch = () => {
    searchText.value = ''
    materialRef.value?.parentgetList?.({ search: '' })
}
const onSearchEnter = async () => {
    materialRef.value?.parentgetList?.({ search: searchText.value })
}
const remainingCapacity = ref(0)
const getCapacity = () => {
    getResourceCapacity({ corp_code: '' }).then(res => {
        if (res.data.code == 200) {
            let arr = res.data.data
            arr.prop = arr.used_capacity / arr.capacity
            remainingCapacity.value = arr
        }
    })
}
const getfilterPage = async () => {
    const res = await getTagPage({ owner_type: 'user', corp_code: '', page: 1, size: 100 })
    tags.value = [{ name: '全部', id: '' }, ...res.data.data.items.map((item: any) => ({ name: item.name, id: item.id }))]
    const res2 = await getCategoryPage({ owner_type: 'user', corp_code: '', page: 1, size: 100 })
    scenes.value = [{ name: '全部', id: '' }, ...res2.data.data.items.map((item: any) => ({ name: item.name, id: item.id }))]
    const res3 = await getCategorySuffixes({ owner_type: 'user', corp_code: '' })
    formats.value = ['全部', ...res3.data.data.items.map((item: any) => (item.file_suffix))]
    console.log(formats.value)
}
</script>
<style lang="scss" scoped>
.team-page {
    width: 100%;
    height: 100%;
    background: #fff;
}

.topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 8px;
}

.title {
    display: inline-flex;
    align-items: center;
    gap: 16px;
}

.title .team-name {
    font-size: 18px;
    font-weight: 600;
    color: #0b1029;
}



.resource-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;

}

.resource-bar .left {
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.res-title {
    font-size: 16px;
    color: #8a8f99;
    font-weight: bolder;
}

.filters {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    margin-left: 12px;
}

.filter-ref {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 10px;
    border-radius: 8px;
    position: relative;

    color: #38393b;
}

.filter-refActive {
    background: #f5f7fa;
}

.filter-ref .label {
    color: #8a8f99;
}

.filter-ref .value {
    color: #2a66ff;
    font-weight: 600;
}

.filter-ref .caret {
    color: #8a8f99;
    transition: transform .2s ease;
}

.filter-ref .clear {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #eef1f5;
    box-shadow: 0 0 0 1px #e6e8eb;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8a8f99;
    cursor: pointer;
    display: none;
    font-size: 12px;
}

.filter-ref:hover .clear {
    display: flex;
}

.filter-ref.open .caret {
    transform: rotate(180deg);
}

.filter-popper .el-dropdown-menu {
    border-radius: 10px;
    padding: 8px;
}

.filter-popper .el-dropdown-menu__item {
    padding: 8px 12px;
}

.filter-popper .el-dropdown-menu__item.active {
    background: #eef1f5;
    color: #2a66ff;
}

.tab {
    font-size: 14px;
    color: #666;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 8px;
}

.tab.active {
    color: #2a66ff;
    font-weight: 600;
    background-color: #eaf2ff;
}

.empty {
    width: 100%;
    height: calc(100vh - 220px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-inner {
    text-align: center;
}

.illu {
    width: 120px;
    height: 120px;
    margin: 0 auto 12px;
    border-radius: 20px;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2a66ff;
    font-weight: 700;
}

.desc {
    font-size: 14px;
    color: #38393b;
    margin-bottom: 8px;
}

.sub {
    font-size: 12px;
    color: #8a8f99;
    margin-bottom: 12px;
}

.btns {
    display: inline-flex;
    gap: 12px;
}

.actions .team-search {
    width: 320px;
}

.actions .team-search :deep(.el-input__wrapper) {
    background-color: #f5f7fa;
    border: 1px solid #eef1f5;
    box-shadow: none;
    border-radius: 10px;
    height: 36px;
}

.actions .team-search :deep(.el-input__inner::placeholder) {
    color: #8a8f99;
}

.actions .team-search :deep(.el-input__suffix) {
    color: #8a8f99;
}

.avatar-stack {
    display: flex;
    align-items: center;
    gap: 0;
}

.avatar-stack .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 0 0 1px #eef1f5;
}

.avatar-stack .avatar+.avatar {
    margin-left: -10px;
}

.avatar-stack .avatar.add {
    background-color: #eaf2ff;
    color: #2a66ff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.upload-btn .caret {
    margin-left: 6px;
}

.typeActive {
    color: #2a66ff;
    font-weight: 600;
}
</style>
